import { Component, Input, OnInit } from '@angular/core';
import { LcvApiService } from '../../services/lcv-api.service';
import { IGraphDis, IResponseCalculos } from '../../models/IResponseCalculos';
import { LcvDataMapperService } from '../../services/lcv-data-mapper.service';
import { ITotalizerTile } from '../../components/totalizer-tiles/ITotalizerTile';
import { BarChartOptions, ChartHelperService, ColumnChartOptions, PieChartOptions } from '../../services/chart-helper.service';
import { forkJoin } from 'rxjs';
import { ITotalStats } from '../../models/ITotalStats'
import { SessionService } from 'src/app/shared/services/session.service';
import { ToastrService } from 'ngx-toastr';
import { IUserInfoCognito } from 'src/app/shared/services/cognito.service';
import { selectUserInfo } from 'src/app/state/selectors/userInfo.selectors';
import { Store } from '@ngrx/store';
import { selectSelectedOrganization } from 'src/app/state/selectors/selectedOrganization.selectors';

export interface IPeriodo {
  value: number;
  isYear: boolean;
  display: string;
}

@Component({
  selector: 'app-lcv-cards-container',
  templateUrl: './lcv-cards-container.component.html',
  styleUrls: ['./lcv-cards-container.component.scss']
})
export class LcvCardsContainerComponent implements OnInit {

  public showTable = true;
  public loadingReport:boolean = true;
  public selectedToggle: string = 'COMPRA';
  public currentYear: number = new Date().getFullYear(); // DEJAR DE USAR
  public periodoSelectedObject: IPeriodo | null = null;
  public selectedPeriodo: string = "0";
  public periodos: IPeriodo[] = [];
  public loadFailed = false;

  public cantidadRegistrosCompra = 0
  public cantidadRegistrosVenta = 0;

  // Compra
  public tilesCompra: ITotalizerTile[] = [];
  public evChartOptionsCompra: ColumnChartOptions | null = null;
  public pieChartYearCompra: PieChartOptions | null = null;
  public pieChartTypeCompra: PieChartOptions | null = null;
  public evProvChartOptions: BarChartOptions | null = null;
  public top10Proveedores: IGraphDis[] = [];

  // Venta
  public tilesVenta: ITotalizerTile[] = [];
  public evChartOptionsVenta: ColumnChartOptions | null = null;
  public pieChartYearVenta: PieChartOptions | null = null;
  public pieChartTypeVenta: PieChartOptions | null = null;
  public evCliChartOptions: BarChartOptions | null = null;
  public top10Clientes: IGraphDis[] = [];
  
  // Selected
  public totalStats: ITotalStats | null = null;
  public selectedTiles: ITotalizerTile[] = [];
  public evChartOptions: ColumnChartOptions | null = null;
  public pieChartYear: PieChartOptions | null = null;
  public pieChartType: PieChartOptions | null = null;
  public evByEntity: BarChartOptions | null = null;
  public top10List: IGraphDis[] = [];

  public userInfo: IUserInfoCognito | null = null;
  private _userInfo$: Observable<IUserInfoCognito> = this.store.select(selectUserInfo);
  
  public selectedOrganization: string | null = this._sessionService.getOrganization();
  private _selectedOrganization$ = this.store.select(selectSelectedOrganization);

  constructor(
    private _apiService: LcvApiService,
    private _mapper: LcvDataMapperService,
    private _chartHelper: ChartHelperService,
    private _sessionService: SessionService,
    private toastr: ToastrService,
    private store: Store
    ) { }

  ngOnInit(): void {
    this._userInfo$.subscribe((userInfo) => {
      this.userInfo = userInfo;
    })
    this._selectedOrganization$.subscribe((selectedOrg)=> {
      this.selectedOrganization = selectedOrg;
    })
    const today = new Date();
    let currentYear = today.getFullYear();
    this.periodos.push({
      value: currentYear,
      isYear: true,
      display: currentYear.toString()
    })
    this.periodos.push({
      value: currentYear - 1,
      isYear: true,
      display: (currentYear -1).toString()
    }),
    this.periodos.push({
      value: currentYear -2,
      isYear: true,
      display: (currentYear - 2).toString()
    });
    this.periodos.push({
      value: 2,
      isYear: false,
      display: "Ultimos dos años"
    });
    this.periodos.push({
      value: 3,
      isYear: false,
      display: "Ultimos tres años"
    })
    this.periodoSelectedObject = this.periodos[0];
    this.getGraphData();
  }

  public onRefresh() {
    this.loadFailed = false;
    this.getGraphData();
  }

  private getGraphData() {
    if(!this.userInfo || !this.selectedOrganization) return
    let currentRut = this.selectedOrganization;
    let currentUser = this.userInfo.email;
    this.loadingReport = true;

    let startYear = this.getStarYearOfPeriod(this.periodoSelectedObject);
    let apiCalls = [
      this._apiService.obtenerCalculos(currentUser, currentRut,'COMPRA', this.getMesesPeriodoActual(),  startYear),
      this._apiService.obtenerCalculos(currentUser, currentRut,'VENTA', this.getMesesPeriodoActual(),  startYear)
    ];
        forkJoin(apiCalls).subscribe((res: IResponseCalculos[]) => {
          this.loadingReport = false;
          if (res.length < 2){
            this.toastr.error('', 'Ha ocurrido un error al obtener los calculos');
            this.loadingReport = false;
          } else {
            this.mapResponseCalculos(res[0], res[1])
            if(this.selectedToggle == 'COMPRA') {
              this.selectValuesCompra();
            } else {
              this.selectValuesVenta();
            }
          }
        },
        ({ error }) => {
          this.toastr.error('', error.message || 'Ha ocurrido un error al obtener los calculos');
          this.loadingReport = false;
          this.loadFailed = true
        })
  }

  getStarYearOfPeriod(period: IPeriodo | null): number {
    if (period && period.isYear) {
      return period.value;
    } else {
      // this.periodoSelectedObject = {
      //   isYear: true,
      //   value: this.currentYear,
      //   display: this.currentYear.toString()
      // }
      return this.currentYear;
    }
  }

  mapResponseCalculos(calculosCompras: IResponseCalculos, calculosVentas: IResponseCalculos) {

    this.cantidadRegistrosVenta = calculosVentas.datosGenerales?.totalRegistros ? calculosVentas.datosGenerales?.totalRegistros : 0;
    this.cantidadRegistrosCompra = calculosCompras.datosGenerales?.totalRegistros ? calculosCompras.datosGenerales?.totalRegistros : 0;

    // *** COMPRAS ***
    this.tilesCompra = this._mapper.mapDatosGrales(calculosCompras.datosGenerales, 'COMPRA');
    
    //REVISAR MAPEO CON PERIODO SELECTED, tendrian que entrar varios
    //SEPARAR POR AÑO EN CASO DE PERIODO

    const evDataCompra = this._mapper.mapEvGraph(calculosCompras.graphEv, this.getYears());
    this.evChartOptionsCompra = this._chartHelper.getEvChartOptions(evDataCompra);

    this.pieChartYearCompra = this._chartHelper.getPieChartOptions(calculosCompras.graphDisPorAnio);
    this.pieChartTypeCompra = this._chartHelper.getPieChartOptions(calculosCompras.graphDisTipo);

    this.top10Proveedores = this._mapper.generarTablaTop10Proveedores(calculosCompras.graphDis);
    const evProveedores = this._mapper.mapGraphDis(calculosCompras.graphDis);
    this.evProvChartOptions = this._chartHelper.getProvClientEvChart(evProveedores);


    // *** VENTAS ***
    this.tilesVenta = this._mapper.mapDatosGrales(calculosVentas.datosGenerales, 'VENTA');
    
    //REVISAR MAPEO CON PERIODO SELECTED, tendrian que entrar varios
    const evDataVenta = this._mapper.mapEvGraph(calculosVentas.graphEv, this.getYears());
    this.evChartOptionsVenta = this._chartHelper.getEvChartOptions(evDataVenta);

    this.pieChartYearVenta = this._chartHelper.getPieChartOptions(calculosVentas.graphDisPorAnio);
    this.pieChartTypeVenta = this._chartHelper.getPieChartOptions(calculosVentas.graphDisTipo);

    this.top10Clientes = this._mapper.generarTablaTop10Proveedores(calculosVentas.graphDis);
    const evClientes = this._mapper.mapGraphDis(calculosVentas.graphDis);
    this.evCliChartOptions = this._chartHelper.getProvClientEvChart(evClientes);


    // *** ESTADISTICOS ***

    //Revisar meses y periodo selected
    const meses = this.getMesesPeriodoActual();
    this.totalStats = this._mapper.mapTotalStats(calculosCompras, calculosVentas, meses, this.getStarYearOfPeriod(this.periodoSelectedObject).toString())
  }

  getMesesPeriodoActual(): string {
    const today = new Date();

    //Chequear si estamos en el año actual
    // en ese caso restarle a 12
    let anioActual = today.getFullYear();
    if(this.periodoSelectedObject && !this.periodoSelectedObject.isYear) {
      let meses = 12*this.periodoSelectedObject.value
      return meses.toString();
    } if (this.periodoSelectedObject && this.periodoSelectedObject.isYear && this.periodoSelectedObject.value == anioActual) {
      let currentMonth = today.getMonth() + 1;
      let meses = currentMonth;
      return meses.toString();
    }
    return "12"
  }

  getYears(): string[] {
    if(this.periodoSelectedObject) {
      if(this.periodoSelectedObject.isYear) {
        return  [this.periodoSelectedObject.display];
      } else {
        let res: string[] = [];
        let count = 0;
        while (count < (this.periodoSelectedObject.value)){
          let value: number = this.currentYear - count; 
          res.push(value.toString());
          count++
        }
        return res;
      }
    } else {
      return [this.currentYear.toString()];
    }
  }

  onCompraVentaToggle(value: string) {
    this.selectedToggle = value;
    if(value == 'COMPRA') {
      this.selectValuesCompra();
    } else {
      this.selectValuesVenta();
    }

    // Resetea la tabla
    this.showTable = false;
    this.showTable = true;
  }

  selectValuesCompra() {
    this.selectedTiles = this.tilesCompra;
    this.pieChartType = this.pieChartTypeCompra;
    this.pieChartYear = this.pieChartYearCompra;
    this.evChartOptions = this.evChartOptionsCompra;
    this.evByEntity = this.evProvChartOptions;
    this.top10List = this.top10Proveedores;
  }

  selectValuesVenta() {
    this.selectedTiles = this.tilesVenta; 
    this.pieChartType = this.pieChartTypeVenta;
    this.pieChartYear = this.pieChartYearVenta;
    this.evChartOptions = this.evChartOptionsVenta;
    this.evByEntity = this.evCliChartOptions;
    this.top10List = this.top10Clientes;
  }

  onSelectedPeriodo(value: any) {
    let periodoSelected = this.periodos.find(obj => {
      return obj.display == value;
    }) 

    if(periodoSelected) {
      this.periodoSelectedObject = periodoSelected
    }
    this.getGraphData();
  }
}


